<template>
  <div style="margin-bottom: 16px">
    <div
      style="display: flex; align-items: end"
      :style="
        message.from != localParticipant.user_id ? 'justify-content: end' : ''
      "
    >
      <div class="avatar" v-if="message.from == localParticipant.user_id">
        <participant-avatar :participant="localParticipant"/>
      </div>
      <div>
        <div
          class="sent-time"
          style="
            font-size: 12px;
            line-height: 16px;
            text-align: left;
            margin-left: 32px;
            padding: 16px 0px 16px 0px;
          "
        >
          {{ this.$moment(message.createdAt).fromNow() }}
        </div>
        <div
          :class="
            message.from == localParticipant.user_id
              ? 'owner-message'
              : 'participant-message'
          "
          v-html="message.html"
        ></div>
      </div>
      <participant-avatar v-if="message.from != localParticipant.user_id" :participant="sender"/>

    </div>
    <div>
      <ul v-if="attachments.length > 0">
        <li
            @click="openAttachment(attachment.downloadURL)"
            :key="attachment.id"
            v-for="attachment in attachments"
        >
          <img
              style="width: 32px; height: 32px; object-fit: cover"
              v-if="attachment.type.startsWith('image/')"
              :src="attachment.downloadURL"
              alt=""
          />
          <span
              v-else
              style="
              display: inline-block;
              width: 32px;
              height: 32px;
              background: black;
            "
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ParticipantAvatar from "@/components/meeting/ParticipantAvatar.vue";

export default {
  name: "MessageListItem",
  components: {ParticipantAvatar},
  props: ["message"],
  computed: {
    meetingId() {
      return this.$store.state.meeting.meeting.id;
    },
    meetingToken() {
      return this.$store.state.meeting.meeting.token.value;
    },
    attachments() {
      return this.message.attachments.map((attachment) => ({
        ...attachment,
        downloadURL: `${process.env.VUE_APP_BACKEND_API_URL}/meetings/${this.meetingId}/attachments/${attachment.id}?meeting_token=${this.meetingToken}`,
      }));
    },
    user() {
      return this.$store.state.user;
    },
    sender() {
      return this.$store.state.meeting.participants.find(it => it.user_id == this.message.from)
    },
    localParticipant() {
      return this.$store.getters.localParticipant;
    },
  },
  methods: {
    openAttachment(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>
.avatar {
  width: 48px;
  height: 48px;
  font-size: 36px;
  font-weight: 400;
  line-height: 48px;
  margin-bottom: 8px;
  /* margin-bottom: 64px; */

  /* @media all and (max-width: 767px) {
    margin-bottom: 32px;
  } */
}
.owner-message {
  width: auto;
  background-color: #fc5a12;
  margin-left: 32px;
  padding: 16px;
  border-radius: 10px;

  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-style: normal;
  font-family: "NunitoSans-Bold";
  letter-spacing: 0px;
  text-align: left;
  line-height: 24px;
}
.owner-message:after {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  border-top: 10px solid #fc5a12;
  top: 0px;
  left: -10px;
}

.participant-message {
  width: auto;
  background-color: #f9f4ef;
  margin-left: 32px;
  padding: 8px;
  border-radius: 10px;

  margin-right: 16px;
  opacity: 1;
  font-size: 16px;
  font-style: normal;
  font-family: "NunitoSans-Bold";
  letter-spacing: 0px;
  text-align: left;
  line-height: 24px;
}
.participant-message:after {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  border-top: 10px solid #f9f4ef;
  top: 0px;
  right: -10px;
}
</style>
